import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const toolbar = [
  [{ header: 1 }, { header: 2 }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ script: 'sub' }, { script: 'super' }],
  ['blockquote', 'code-block', 'link'],
  ['clean'],
];

export default function RichTextEditor(props) {
  return (
    <ReactQuill
      {...props}
      modules={{ toolbar }}
      style={{
        minHeight: '4rem',
        maxHeight: '10rem'
      }}
    />
  );
}
